module.exports = __webpack_public_path__ + "assets/img/mangguoke_316_3.ca89bdb0.jpg";